<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo">                     
       <i class="fas fa-home icon"></i>
        Inicio
        </div>
      <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="breadcrumbs">
                  <ul> 
                    <li class="is-active">
                     <router-link :to="{name:'administrativeHome'}" >
                        <span class="has-text-black" >
                          <i class="fas fa-home icon"></i> 
                             
                        inicio
                      </span>
                    </router-link>
                        
                      </li>
                      <li></li>
                  </ul>
                </nav>
  
      </div>
      <div slot="contenido">
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from "../../template/PlantillaContenido";
export default {
  name: "AdministrativeHome",
  components: {
    PlantillaContenido: PlantillaContenido
  },
  data() {
    return {
      

    };
  }
};
</script>